export enum FetchableEntityType {
    ReleaseStats = 'FETCHABLE_ENTITY_TYPE_RELEASE_STATS',
    GetReleaseOverview = 'FETCHABLE_ENTITY_TYPE_GET_RELEASE_OVERVIEW',
    RolloutMonitoring = 'FETCHABLE_ENTITY_TYPE_ROLLOUT_MONITORING',
    FeatureFlags = 'FETCHABLE_ENTITY_TYPE_FEATURE_FLAGS',
    Release = 'FETCHABLE_ENTITY_TYPE_RELEASE',
    ReleaseStep = 'FETCHABLE_ENTITY_TYPE_RELEASE_STEP',
    OrgOverviewV2 = 'FETCHABLE_ENTITY_TYPE_ORG_OVERVIEW_V2',
    OrgSummaryView = 'FETCHABLE_ENTITY_TYPE_ORG_SUMMARY_VIEW',
    AppState = 'FETCHABLE_ENTITY_TYPE_APP_STATE',
    AppHome = 'FETCHABLE_ENTITY_TYPE_APP_HOME',
    BuildDistributionBucketsWithRecentBuilds = 'FETCHABLE_ENTITY_TYPE_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS',
    BuildDistributionBucket = 'FETCHABLE_ENTITY_TYPE_BUILD_BUCKET',
    BuildDistributionBucketBuild = 'FETCHABLE_ENTITY_TYPE_BUILD_BUCKET_BUILD',
    ProvisioningProfiles = 'FETCHABLE_ENTITY_TYPE_PROVISIONING_PROFILES',
    BuildDistributionBucketDownloadMetrics = 'FETCHABLE_ENTITY_TYPE_BUILD_DISTRIBUTION_BUCKET_DOWNLOAD_METRICS',
    OrgDestinationsAndVersions = 'FETCHABLE_ENTITY_TYPE_ORG_DESTINATIONS_AND_VERSIONS',
}

export enum FetchableEntityTypeV2 {
    WorkflowOverview = 'FETCHABLE_ENTITY_TYPE_WORKFLOW_OVERVIEW',
    Workflow = 'FETCHABLE_ENTITY_TYPE_WORKFLOW',
    WorkflowRun = 'FETCHABLE_ENTITY_TYPE_WORKFLOW_RUN',
    StepRun = 'FETCHABLE_ENTITY_TYPE_STEP_RUN',
    StepRunsSummary = 'FETCHABLE_ENTITY_TYPE_STEP_RUNS_SUMMARY',
    StepConfig = 'FETCHABLE_ENTITY_TYPE_STEP_CONFIG',
    OrgChecklistItemTemplates = 'FETCHABLE_ENTITY_TYPE_ORG_CHECKLIST_ITEM_TEMPLATES',
}

export enum FetchablePaginatedEntityType {
    Releases = 'FETCHABLE_ENTITY_TYPE_RELEASES',
    BuildDistributionBucketBuilds = 'FETCHABLE_ENTITY_TYPE_BUILD_BUCKET_BUILDS',
    BuildDistributionSharedWithMeBuilds = 'FETCHABLE_ENTITY_TYPE_BUILD_SHARED_WITH_ME_BUILDS',
    BuildDistributionBuildWorkItemsTimeline = 'FETCHABLE_ENTITY_TYPE_BUILD_DISTRIBUTION_BUILD_WORK_ITEMS_TIMELINE',
    AllDevices = 'FETCHABLE_ENTITY_TYPE_ALL_DEVICES',
}
